const LanguageList = [
  { code: "en", language: "English" },
  { code: "de", language: "German" },
  { code: "pt", language: "Portuguese" },
  { code: "nl", language: "Dutch" },
  { code: "fi", language: "Finnish" },
  { code: "da", language: "Danish" },
  { code: "fr", language: "French" },
  { code: "es", language: "Spanish" },
  { code: "et", language: "Estonian" },
  { code: "pl", language: "Polish" },
  { code: "no", language: "Norwegian" },
];

export const IsoRegionLanguageList = [
  // Danish
  { isoName: "da-DK", displayName: "Danish (DK)" }, // Denmark

  // Dutch
  { isoName: "nl-BE", displayName: "Dutch (BE)" }, // Belgium (Flemish)
  { isoName: "nl-NL", displayName: "Dutch (NL)" }, // Netherlands

  // English
  { isoName: "en-AU", displayName: "English (AU)" }, // Australia
  { isoName: "en-CA", displayName: "English (CA)" }, // Canada
  { isoName: "en-GB", displayName: "English (GB)" }, // United Kingdom
  { isoName: "en-NZ", displayName: "English (NZ)" }, // New Zealand
  { isoName: "en-US", displayName: "English (US)" }, // United States

  // Estonian
  { isoName: "et-EE", displayName: "Estonian (EE)" }, // Estonia

  // Finnish
  { isoName: "fi-FI", displayName: "Finnish (FI)" }, // Finland

  // French
  { isoName: "fr-BE", displayName: "French (BE)" }, // Belgium
  { isoName: "fr-CA", displayName: "French (CA)" }, // Canada (Québécois French)
  { isoName: "fr-CH", displayName: "French (CH)" }, // Switzerland
  { isoName: "fr-FR", displayName: "French (FR)" }, // France

  // German
  { isoName: "de-AT", displayName: "German (AT)" }, // Austria
  { isoName: "de-CH", displayName: "German (CH)" }, // Switzerland
  { isoName: "de-DE", displayName: "German (DE)" }, // Germany

  // Norwegian
  { isoName: "no-NO", displayName: "Norwegian (NO)" }, // Norway (Bokmål)

  // Polish
  { isoName: "pl-PL", displayName: "Polish (PL)" }, // Poland

  // Portuguese
  { isoName: "pt-PT", displayName: "Portuguese (PT)" }, // Portugal

  // Spanish
  { isoName: "es-ES", displayName: "Spanish (ES)" }, // Spain (Castilian)
];
export default LanguageList;
